
<form [formGroup]="labSampleForm"  class="example-form w-100 mb-2" style="height:auto; overflow-y: auto;"><!--(ngSubmit)="onSubmit()"-->
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.labSampleForm.materialID' | translate}}</mat-label>
        <input formControlName="materialID" matInput type="text" readonly>
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.labSampleForm.type' | translate}}</mat-label>
        <mat-select formControlName="type" disabled>
            <mat-option *ngFor="let method of dropdownType" [value]="method">{{method.title}}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.labSampleForm.comment' | translate}}</mat-label>
        <textarea formControlName="comment" matInput readonly></textarea>
    </mat-form-field>

    <div *ngFor =" let examination of labSampleForm.value.examinations; let index = index" class="list-group my-2">
        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.approvalTimestamp' | translate}}: </span>
            <span>{{getTimeFirebaseTimestamp(examination.approvalTimestamp) | date: 'dd.MM.yyyy, HH:mm'}}</span>
        </div>

        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.checkDate' | translate}}: </span>
            <span>{{getTimeFirebaseTimestamp(examination.checkDate) | date: 'dd.MM.yyyy, HH:mm'}}</span>
        </div>

        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.examinationDisease' | translate}}: </span>
            <span>{{examination.examinationDisease}}</span>
        </div>
        
        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.examinationMethod' | translate}}: </span>
            <span>{{examination.examinationMethod}}</span>
        </div>
        
        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.receiptDate' | translate}}: </span>
            <span>{{getTimeFirebaseTimestamp(examination.receiptDate) | date: 'dd.MM.yyyy, HH:mm'}}</span>
        </div>
        
        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.result' | translate}}: </span>
            <span>{{examination.result}}</span>
        </div>

        <div class="list-group-item">
            <span >{{'FORM.labSampleForm.examinations.resultValue' | translate}}: </span>
            <span>{{examination.resultValue}}</span>
        </div>
    </div>
</form>